export default __webpack_public_path__ + "static/media/task_health_info_icon.cb09b99d.svg";